module.exports = __webpack_public_path__ + "img/组 127@2x.9b7912f7.png";